import type { UUID } from '@/utils/uuid';

export const connectorQueryKeys = {
  list: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['connectors', tenantId, limit ?? null, filter ?? null] as const,
  listByTenant: (tenantId?: UUID) => ['connectors', tenantId] as const,
  detail: (tenantId?: UUID, connectorId?: UUID) =>
    ['connector', tenantId, connectorId] as const,
  featureList: (
    tenantId?: UUID,
    connectorId?: UUID,
    limit?: number,
    filter?: string
  ) =>
    ['features', tenantId, connectorId, limit ?? null, filter ?? null] as const,
  featureListByConnector: (tenantId?: UUID, connectorId?: UUID) =>
    ['features', tenantId, connectorId] as const,
  featureDetail: (tenantId?: UUID, connectorId?: UUID, featureId?: UUID) =>
    ['feature', tenantId, connectorId, featureId] as const,
  featuresWithProviderOptions: (
    tenantId?: UUID,
    connectorId?: UUID,
    limit?: number,
    filter?: string
  ) =>
    [
      'connector-features-with-provider-options',
      tenantId,
      connectorId,
      limit ?? null,
      filter ?? null,
    ] as const,
  invocationStatusesByFeature: (
    tenantId?: UUID,
    connectorId?: UUID,
    featureId?: UUID
  ) => ['invocation-statuses', tenantId, connectorId, featureId] as const,
  invocationStatuses: (
    tenantId?: UUID,
    connectorId?: UUID,
    featureId?: UUID,
    limit?: number,
    next?: string
  ) =>
    [
      'invocation-statuses',
      tenantId,
      connectorId,
      featureId,
      limit ?? null,
      next ?? null,
    ] as const,
  invocationStatus: (
    tenantId?: UUID,
    connectorId?: UUID,
    featureId?: UUID,
    runSequence?: number
  ) =>
    [
      'invocation-status',
      tenantId,
      connectorId,
      featureId,
      runSequence ?? null,
    ] as const,
  currentInvocationStatus: (
    tenantId?: UUID,
    connectorId?: UUID,
    featureId?: UUID
  ) => ['current-invocation-status', tenantId, connectorId, featureId] as const,
  currentInvocationStatusesByConnector: (tenantId?: UUID, connectorId?: UUID) =>
    [
      'current-invocation-statuses-by-connector',
      tenantId,
      connectorId,
    ] as const,
  currentSequence: (tenantId?: UUID, connectorId?: UUID, featureId?: UUID) =>
    ['current-sequence', tenantId, connectorId, featureId] as const,
  configurationStatus: (tenantId?: UUID, connectorId?: UUID) =>
    ['connector-configuration-status', tenantId, connectorId] as const,
};

export const connectorMutationKeys = {
  createConnector: (tenantId?: UUID) => ['createConnector', tenantId] as const,
  updateConnector: (tenantId?: UUID, connectorId?: UUID) =>
    ['updateConnector', tenantId, connectorId] as const,
  deleteConnector: (tenantId?: UUID) => ['deleteConnector', tenantId] as const,
  requestConnectorInvocation: (tenantId?: UUID, connectorId?: UUID) =>
    ['requestConnectorInvocation', tenantId, connectorId] as const,
  stopConnectorInvocation: (tenantId?: UUID, connectorId?: UUID) =>
    ['stopConnectorInvocation', tenantId, connectorId] as const,
  enableConnector: (tenantId?: UUID) => ['enableConnector', tenantId] as const,
  disableConnector: (tenantId?: UUID) =>
    ['disableConnector', tenantId] as const,
  reconcileConnectorFeature: (tenantId?: UUID, connectorId?: UUID) =>
    ['reconcileConnectorFeature', tenantId, connectorId] as const,
  unbindConnectorFeatureCredential: (tenantId?: UUID, connectorId?: UUID) =>
    ['unbindConnectorFeatureCredential', tenantId, connectorId] as const,
};
